// Chargebee.js: Chargebee's own secure screens (checkout, card on file), shown as a
// pop-up over the Morsel page, so people never leave Morsel and Morsel never sees
// a card number.

const SCRIPT = 'https://js.chargebee.com/v2/chargebee.js'
let loading = null

const load = () => {
  if (window.Chargebee) return Promise.resolve(window.Chargebee)
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script')
      s.src = SCRIPT
      s.async = true
      s.onload = () => resolve(window.Chargebee)
      s.onerror = () => {
        loading = null
        reject(new Error('Chargebee could not load'))
      }
      document.head.appendChild(s)
    })
  }
  return loading
}

let instance = null
const cb = async (site) => {
  const Chargebee = await load()
  if (!instance) instance = Chargebee.init({ site })
  return { Chargebee, instance }
}

// Opens a hosted checkout page (from our API) over the page
export const openCheckout = async (site, hostedPage) => {
  const { instance: c } = await cb(site)
  return new Promise((resolve) => {
    let done = false
    c.openCheckout({
      hostedPage: () => Promise.resolve(hostedPage),
      success: (hostedPageId) => {
        done = true
        resolve({ paid: true, hostedPageId })
        // Chargebee leaves its screen open after paying; Morsel shows the result instead
        c.closeAll()
      },
      close: () => resolve({ paid: done }),
    })
  })
}

// Opens Chargebee's "payment methods" screen (replace the card) over the page
export const openCardScreen = async (site, getSession) => {
  const { Chargebee, instance: c } = await cb(site)
  c.setPortalSession(() => getSession())
  const portal = c.createChargebeePortal()
  return new Promise((resolve) => {
    portal.openSection(
      { sectionType: Chargebee.getPortalSections().PAYMENT_SOURCES },
      { close: () => resolve() }
    )
  })
}
